import AppSettings from 'src/app/common/app.settings';
import { locationMock } from 'src/app/common/base-test.helpers.spec';
import {
  AccountStatus,
  ConnectionStatus,
  Doctor,
  FullUser,
  GeneralProfileData,
  Individual,
  MedStaff,
  OrganizationLink,
  Patient,
  Researcher,
  Suffixes,
  UserBasic,
  UserRole,
} from 'src/app/swagger-api';

const generalProfileData: GeneralProfileData = {
  email: 'example@example.com',
  verified_email: 'example@example.com',
  location: locationMock,
  about: '',
  phone_number: '+17755550151',
};

export const patient: (hasDiseases: boolean) => Patient = (hasDiseases = true) => {
  return {
    patient_id: '4587854231',
    insured: 'YES',
    insurance_carrier_text: 'Blue Shield of California Health Insurance',
    place_of_birth: 'California',
    diseases: hasDiseases ? [{ entity_id: 'test_id', title: 'Stroke' }] : [],
  };
};

export const individual: (suffix?: Suffixes) => Individual = (suffix: Suffixes = Suffixes.Empty) => {
  return {
    first_name: 'John',
    middle_name: 'Aaron',
    last_name: 'Smith',
    suffix,
    gender: 'Male',
    date_of_birth: '11/05/1971',
    language: ['English'],
  };
};

export const doctor: Doctor = {
  specialty: [{ entity_id: 'test_id_1', title: 'Neurology' }],
  treatment_of_diseases: [
    { entity_id: 'test_id_2', title: 'Stroke' },
    { entity_id: 'test_id_3', title: 'Epilepsy' },
    { entity_id: 'test_id_4', title: 'MD' },
    { entity_id: 'test_id_5', title: 'MRSA' },
  ],
  education: 'Felician College, 2018 BSN',
  fellowship: 'Stanford University Medical Center 2001 Rush University Medical Center, Movement Disorders 2003',
};

export const medStaff: MedStaff = {
  ...doctor,
  organization_which_represented: [
    {
      organization_name: 'St. Maria Hospital',
      organization_link_kind: OrganizationLink.OrganizationLinkKindEnum.CUSTOM,
      organization_user_id: '',
    },
  ],
};

export const researcher: Researcher = {
  organization_which_represented: [
    {
      organization_name: 'St. Maria Hospital',
      organization_link_kind: OrganizationLink.OrganizationLinkKindEnum.CUSTOM,
      organization_user_id: '',
    },
  ],
  specialty: [{ entity_id: 'test_id_1', title: 'Neurology' }],
  diseases: [{ entity_id: 'test_id_2', title: 'Stroke' }],
};

export const patientUser: (hasDiseases: boolean) => FullUser = (hasDiseases = true) => {
  return {
    user_id: 'test_id',
    image_url: AppSettings.DEFAULT_USER_IMAGE,
    displayed_name: 'asdfghj',
    is_admin: false,
    account_status: AccountStatus.ACTIVE,
    profile: generalProfileData,
    individual: individual(),
    patient: patient(hasDiseases),
    reaction: {
      blocked: false,
      connection_details: {
        status: ConnectionStatus.Pending,
        initiator_id: 'test_id',
      },
    },
    user_roles: [UserRole.Patient],
  };
};

export const doctorUser: FullUser = {
  user_id: 'test_id',
  image_url: AppSettings.DEFAULT_USER_IMAGE,
  displayed_name: 'asdfghj',
  is_admin: false,
  account_status: AccountStatus.ACTIVE,
  profile: generalProfileData,
  individual: individual(),
  doctor: doctor,
  reaction: {
    blocked: false,
    connection_details: {
      status: ConnectionStatus.Pending,
      initiator_id: 'test_id',
    },
  },
  user_roles: [UserRole.Doctor],
};

export const medStaffUser: FullUser = {
  user_id: 'test_id',
  image_url: AppSettings.DEFAULT_USER_IMAGE,
  displayed_name: 'asdfghj',
  is_admin: false,
  account_status: AccountStatus.ACTIVE,
  profile: generalProfileData,
  individual: individual(),
  med_staff: medStaff,
  reaction: {
    blocked: false,
    connection_details: {
      status: ConnectionStatus.Pending,
      initiator_id: 'test_id',
    },
  },
  user_roles: [UserRole.MedStaff],
};

export const researcherUser: FullUser = {
  user_id: 'test_id',
  image_url: AppSettings.DEFAULT_USER_IMAGE,
  displayed_name: 'asdfghj',
  is_admin: false,
  account_status: AccountStatus.ACTIVE,
  profile: generalProfileData,
  individual: individual(),
  researcher,
  reaction: {
    blocked: false,
    connection_details: {
      status: ConnectionStatus.Pending,
      initiator_id: 'test_id',
    },
  },
  user_roles: [UserRole.Researcher],
};

export const multipleRolesUser: FullUser = {
  user_id: 'test_id',
  image_url: AppSettings.DEFAULT_USER_IMAGE,
  displayed_name: 'asdfghj',
  is_admin: false,
  account_status: AccountStatus.ACTIVE,
  profile: generalProfileData,
  individual: individual(),
  researcher,
  doctor: doctor,
  patient: patient(true),
  reaction: {
    blocked: false,
    connection_details: {
      status: ConnectionStatus.Pending,
      initiator_id: 'test_id',
    },
  },
  user_roles: [UserRole.Patient, UserRole.Doctor, UserRole.Researcher],
};

export const noRolesYetUser: FullUser = {
  user_id: 'test_id',
  image_url: AppSettings.DEFAULT_USER_IMAGE,
  displayed_name: 'asdfghj',
  is_admin: false,
  account_status: AccountStatus.ACTIVE,
  profile: generalProfileData,
  individual: {} /* empty */,
  reaction: {
    blocked: false,
    connection_details: {
      status: ConnectionStatus.Pending,
      initiator_id: 'test_id',
    },
  },
  user_roles: [],
};

export const mockProfile: FullUser = {
  user_id: 'userid22222',
  displayed_name: 'JhonSmith',
  is_admin: false,
  account_status: AccountStatus.ACTIVE,
  profile: {
    email: 'dntlab+jhonsmith@example.com.com',
    verified_email: 'dntlab+william@example.com.com',
    location: locationMock,
  },
  reaction: {
    blocked: false,
    connection_details: {
      status: ConnectionStatus.Pending,
      initiator_id: 'test_id',
    },
  },
  user_roles: [],
};

export const mockUser: FullUser = {
  user_id: 'userid',
  displayed_name: 'William',
  is_admin: false,
  account_status: AccountStatus.ACTIVE,
  image_url: 'https://example.com/jhjhj',
  profile: {
    email: 'dntlab+william@example.com.com',
    verified_email: 'dntlab+william@example.com.com',
    phone_number: '+1-775-555-0151',
    location: locationMock,
    about: '',
  },
  individual: {
    first_name: '89701',
    middle_name: '',
    last_name: 'Nelson',
    gender: 'Male',
    date_of_birth: '9/12/1950',
    language: ['English'],
  },
  patient: {
    patient_id: '2345678123',
    insured: 'NO',
    insurance_carrier_text: '',
    place_of_birth: 'Nigeria',
    diseases: [{ entity_id: 'test_id', title: 'Stroke' }],
  },
  reaction: {
    blocked: false,
    connection_details: {
      status: ConnectionStatus.Pending,
      initiator_id: 'test_id',
    },
  },
  user_roles: [UserRole.Patient],
};

export const mockIndividualUncompletedUser: FullUser = {
  user_id: 'f5f82d089a6148f4ae4439c5f4a35235',
  displayed_name: 'My test alias',
  is_admin: false,
  account_status: AccountStatus.ACTIVE,
  user_roles: [],
  reaction: { blocked: false },
  profile: {
    email: 'test@example.com',
    verified_email: 'test@example.com',
  },
  individual: {},
};

export const mockIndividualCompletedUser: FullUser = {
  user_id: 'f5f82d089a6148f4ae4439c5f4a35235',
  displayed_name: 'My test alias',
  is_admin: false,
  account_status: AccountStatus.ACTIVE,
  user_roles: ['patient'],
  reaction: { blocked: false },
  profile: {
    email: 'test@example.com',
    verified_email: 'test@example.com',
    location: {
      country: {
        full_name: 'United States',
        alpha2: 'US',
      },
      city: 'Redcrest',
      center: {
        lat: 40.396882571501045,
        lon: -123.94817783976244,
      },
      region: 'California',
      subregion: 'Humboldt County',
      street: 'Avenue of the Giants',
    },
  },
  individual: {
    gender: 'Male',
    date_of_birth: '1990-04-18',
    first_name: 'John',
    last_name: 'Smith',
    middle_name: 'Boy',
    suffix: 'Mr.',
    language: ['English'],
  },
  patient: {
    patient_id: '29cd889235a64af89b5d911bb503492f',
    insured: 'NO',
    place_of_birth: 'London',
    diseases: [],
  },
};

export const mockUsers: UserBasic[] = [
  {
    user_id: 'userid',
    displayed_name: 'Diana',
    is_admin: false,
    account_status: AccountStatus.ACTIVE,
    image_url: 'https://example.com/jhjhj',
  },
  {
    user_id: 'userid1',
    displayed_name: 'William',
    is_admin: false,
    account_status: AccountStatus.ACTIVE,
  },
  {
    user_id: 'userid2',
    displayed_name: 'Bob',
    is_admin: false,
    account_status: AccountStatus.ACTIVE,
  },
];

export interface TestDataRoles {
  role: string;
  definitions: string[];
}
